import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Import new redesigned components
import { NewHeader } from "./components/NewHeader";
import { NewHeroSection } from "./components/NewHeroSection";
import { NewStatsSection } from "./components/NewStatsSection";
import { NewBenefitsSection } from "./components/NewBenefitsSection";
import { NewVideoSection } from "./components/NewVideoSection";
import { NewIndustriesSection } from "./components/NewIndustriesSection";
import { NewContactSection } from "./components/NewContactSection";
import { NewFooter } from "./components/NewFooter";

const NewLandingPage = () => {
  useEffect(() => {
    // Smooth scrolling for anchor links
    const handleSmoothScroll = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        e.preventDefault();
        const id = target.getAttribute('href').substring(1);
        const element = document.getElementById(id);
        if (element) {
          const headerOffset = 80; // Account for fixed header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <NewHeader />
      
      {/* Hero Section */}
      <section id="home">
        <NewHeroSection />
      </section>
      
      {/* Stats Section */}
      <section id="stats">
        <NewStatsSection />
      </section>
      
      {/* Benefits Section */}
      <section id="benefits">
        <NewBenefitsSection />
      </section>
      
      {/* Video Section */}
      <section id="solution">
        <NewVideoSection />
      </section>
      
      {/* Industries Section */}
      <section id="industries">
        <NewIndustriesSection />
      </section>
      
      {/* Contact Section */}
      <section id="contact">
        <NewContactSection />
      </section>
      
      <NewFooter />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NewLandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;